// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qr {
  position: fixed;
  bottom: calc(var(--ion-safe-area-bottom) + 70px);
  left: -110px;
  background-color: var(--orwi-qr-button-color);
  display: flex;
  width: 150px;
  height: 50px;
  color: white;
  align-items: center;
  justify-content: center;
  box-shadow: var(--orwi-shadow);
  border: 2px solid white;
  z-index: 102;
  border-radius: 15px;
  transition: left 0.3s;
  padding: 10px;
}

.orwi-actio-backdrop {
  background-color: rgba(171, 172, 173, 0.6196078431);
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 100;
  top: 0px;
}

.anim-button {
  background-color: transparent;
  transition: transform 0.2s cubic-bezier(0, 0.79, 0.32, 1.28);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 30px;
  left: 20px;
  background-color: var(--ion-color-primary);
  display: flex;
  width: 60px;
  height: 60px;
  color: white;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: var(--orwi-shadow);
  border: 2px solid white;
  z-index: 101;
}

.web-trans1 {
  transform: translate3d(-90px, 15px, 20px);
}

.web-trans2 {
  transform: translate3d(-90px, -70px, 20px);
}

.web-trans3 {
  transform: translate3d(-90px, -155px, 20px);
}

@keyframes web-trans3 {
  0% {
    transform: translate3d(50px, 40px, 0px);
    animation-timing-function: ease-in;
  }
  50% {
    transform: translate3d(50px, 50px, 0px);
    animation-timing-function: ease-out;
  }
  100% {
    transform: translate3d(50px, 40px, 0px);
  }
}
.text {
  background-color: rgba(0, 0, 0, 0.5803921569);
  color: white;
  padding: 4px;
  font-size: 12px;
  margin-bottom: 5px;
  transition: opacity 1s ease-in-out;
  opacity: 0;
  position: absolute;
  right: 70px;
  width: 100px;
  top: 20px;
  text-align: center;
}

.text-open {
  opacity: 1;
}

.button {
  position: fixed;
  right: 20px;
  background-color: transparent;
  width: 60px;
  height: 60px;
  z-index: 14;
}

.button-cover {
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.4196078431);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ui/web-fab/web-fab.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gDAAA;EACA,YAAA;EACA,6CAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AACF;;AAEA;EACE,mDAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AACF;;AAEA;EACE,6BAAA;EACA,4DAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,YAAA;EACA,UAAA;EACA,0CAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;EACA,uBAAA;EACA,YAAA;AAAF;;AAGA;EAEE,yCAAA;AADF;;AAIA;EAEE,0CAAA;AAFF;;AAKA;EAEE,2CAAA;AAHF;;AAMA;EACE;IACE,uCAAA;IACA,kCAAA;EAHF;EAKA;IACE,uCAAA;IACA,mCAAA;EAHF;EAKA;IACE,uCAAA;EAHF;AACF;AAMA;EACE,6CAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,UAAA;EAEA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,eAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EAEA,WAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,6CAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AANF","sourcesContent":[".qr {\n  position: fixed;\n  bottom: Calc(var(--ion-safe-area-bottom) + 70px);\n  left: -110px;\n  background-color: var(--orwi-qr-button-color);\n  display: flex;\n  width: 150px;\n  height: 50px;\n  color: white;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--orwi-shadow);\n  border: 2px solid white;\n  z-index: 102;\n  border-radius: 15px;\n  transition: left  0.3s;\n  padding: 10px;\n}\n\n.orwi-actio-backdrop {\n  background-color: #abacad9e;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 100;\n  top: 0px;\n}\n\n.anim-button {\n  background-color: transparent;\n  transition: transform 0.2s cubic-bezier(0, 0.79, 0.32, 1.28);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  position: fixed;\n  bottom: 30px;\n  left: 20px;\n  background-color: var(--ion-color-primary);\n  display: flex;\n  width: 60px;\n  height: 60px;\n  color: white;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  box-shadow: var(--orwi-shadow);\n  border: 2px solid white;\n  z-index: 101;\n}\n\n.web-trans1 {\n  //transform: translate3d(-120px, 15px, 20px);\n  transform: translate3d(-90px, 15px, 20px);\n}\n\n.web-trans2 {\n  //transform: translate3d(-90px, -80px, 20px);\n  transform: translate3d(-90px, -70px, 20px);\n}\n\n.web-trans3 {\n  //transform: translate3d(10px, -150px, 20px);\n  transform: translate3d(-90px, -155px, 20px);\n}\n\n@keyframes web-trans3 {\n  0% {\n    transform: translate3d(50px, 40px, 0px);\n    animation-timing-function: ease-in;\n  }\n  50% {\n    transform: translate3d(50px, 50px, 0px);\n    animation-timing-function: ease-out;\n  }\n  100% {\n    transform: translate3d(50px, 40px, 0px);\n  }\n}\n\n.text {\n  background-color: #00000094;\n  color: white;\n  padding: 4px;\n  font-size: 12px;\n  margin-bottom: 5px;\n  transition: opacity 1s ease-in-out;\n  opacity: 0;\n\n  position: absolute;\n  right: 70px;\n  width: 100px;\n  top: 20px;\n  text-align: center;\n}\n\n.text-open {\n  opacity: 1;\n}\n\n.button {\n  position: fixed;\n  right: 20px;\n  background-color: transparent;\n  width: 60px;\n  height: 60px;\n\n  z-index: 14;\n}\n\n.button-cover {\n  width: 50px;\n  height: 50px;\n  background-color: #0000006b;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
